export enum Role {
  VIEWER,
  PLAYER,
  EXPORTER,
  MASTERSIM,
  ADMIN,
  NONE
}

export interface User {
  email: string;
  familyName: string;
  givenName: string;
  picture: string;
  fullName: string;
  roles: Array<Role>;
  accesses: Array<string>;
  bearer?: string;
  bearerExp?: number;
  iobaseBearer?: string;
  iobaseBearerExp?: number;
}
